import APP from 'src/main.js'
import AppRecord from './AppRecord.js'
class DocumentRelation extends AppRecord {
  set document(v){
    this._document = v
  }
  get document(){
    if(this._document){
      return this._document
    } else {
      return this.constructor.employeeStore.documents.find(doc => doc.id == this.document_id)
    }
  }
  get filename(){
    if(this._filename){return this._filename}
    if(this.document){
      this._filename = this.document.filename
      return this._filename
    } else {
      return undefined
    }
  }
  get key(){
    return `${this.id}-${this.document_id}-${this.owner_id}-${this.owner_type}`
  }
  get valid(){
    if(this.id){
      return true
    } else {
      return !!this.owner_id && !!this.owner_type && (this._document||this.document_id) && this.is_unique
    }
  }
  get is_unique(){
    return this.document.document_relations.filter((rel) => {
      return (rel.owner_id == this.owner_id)&&(rel.owner_type == this.owner_type)
    }).length == 1
  }
}
export default DocumentRelation
